import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type { BaseApiResponse } from "../../../types/api.ts"

const PATH = "/notifications/sms/retention/"

export interface SmsRetentionSettings {
  sms_retention_days: number
  default_days: number
  minimum_days: number
  maximum_days: number
}

export const getSmsRetentionSettings = (): Promise<
  ApiResponse<SmsRetentionSettings>
> => request.api.get(PATH)

export const updateSmsRetentionSettings = (payload: {
  sms_retention_days: number
}): Promise<ApiResponse<BaseApiResponse<SmsRetentionSettings>>> =>
  request.api.patch(PATH, payload)
